import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Colli } from '../domain/Colli';

@Injectable({
    providedIn: 'root'
})
export class ColliService {

    constructor(private httpClient: HttpClient) { }

    // updateColli(colli: any) {
    //     let colliUpdateCommand = { colli: colli };
    //     return this.httpClient.post(`${environment.apiUrl}/collis/update`, colliUpdateCommand);
    // }

    updateColliLine(colli: any) {
        return this.httpClient.post(`${environment.apiUrl}/collis/updateLine`, colli);
    }

    createColli(colli: any) {
        return this.httpClient.post(`${environment.apiUrl}/collis/create`, colli);
    }

    deleteColli(colli: any) {
        let deleteColliCommand = { id: colli.id };
        return this.httpClient.post(`${environment.apiUrl}/collis/delete`, deleteColliCommand);
    }

    deleteColliLine(colli: any) {
        let deleteColliLineCommand = { lineId: colli.lineId };
        return this.httpClient.post(`${environment.apiUrl}/collis/deleteLine`, deleteColliLineCommand);
    }
    /**
     * 
     * @param shipmentId the shipmentId
     * @param collis should contain ALL collis from the shipment eg how the shipment actuel should look.
     * @returns <{shipmentId,collis,source}> of how the shipment looks, just replace the data with this and you are all good 
     * @description this enpont is of the kind Upsert meaning this will handle cud from CRUD, so its importen to send how the shipment
     * should look with all the collis on that shipment.
     */
    UpsertColliLines(shipmentId: string, collis: Colli[]) {        
        return this.httpClient.post<{ item: { shipmentId: string, colli: Colli[] } }>(`${environment.apiUrl}/e/colli/upsertColli`, { ShipmentId: shipmentId, Collis: collis, Source: "OnlinebookBff" });
    }

}

// export interface UpsertColli {
//     ShipmentId: string;
//     Collis: any[];
//     Source: string;
// }

